var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHasPeanut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "154.1 7.0568 10.9375 16.9315",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c5d80f;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #acb504;\n      }\n\n      .cls-3 {\n        fill: #fec95d;\n      }\n\n      .cls-4 {\n        fill: #dd9f33;\n      }\n\n      .cls-5 {\n        fill: #f2705a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165,18.3c0,2.4-1.6,4.7-3.8,5.4-1.6.5-3.7.4-5-.7-.4-.4-.8-.8-1.1-1.3-.6-.9-1-2.1-1-3.2,0-.9.2-1.9.6-2.7.4-.9,1.3-1.6,1.1-2.7-.2-1.7,0-3.3,1.2-4.6,1.1-1.1,2.6-1.6,4.1-1.4,1.7.2,3,1.4,3.6,2.9.3.8.4,1.6.3,2.5-.1.9-.8,1.8-.7,2.7,0,0,0,0,0,.1,0,0,0,0,0,0,.3.8.6,1.7.7,2.6,0,.1,0,.3,0,.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.5,7.6s0,0,0,0h.2c-.1,1.1-.3,2.1-.4,3.2,0,.1,0,.2-.2.2-.6,0-1.1,0-1.7,0-.1,0-.1,0-.1-.2.1-.7.3-1.3.7-1.9.3-.5.6-.9,1.2-1.2.1,0,.3-.1.4-.1,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M161.3,7.7s0,0,0,0c.6.4.8,1,1,1.7.2.6.2,1.3.1,2,0,.1,0,0-.1,0-.3-.1-.5-.2-.8-.3-.2,0-.4-.1-.6-.1-.1,0-.2,0-.2-.2.1-1,.3-2.1.4-3.1h.2s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.8,17.6c0,.2,0,.5,0,.7v-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M159.4,17.5c0,.6-.2,1.3-.2,1.9,0,.1,0,.2-.2.1-.7-.1-1.4-.3-2.1-.7-.1,0-.2-.1-.2-.3,0-.9.3-1.8.7-2.7.1-.2.2-.5.3-.7,0,0,0,0,.1,0,.6,0,1.1.1,1.7.2.1,0,.1,0,0,.2,0,.6-.2,1.3-.2,1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M159.9,17.5c0-.6.2-1.3.2-1.9,0-.1,0-.2.2-.2.4,0,.9.1,1.3.2.1,0,.2,0,.2.2,0,.4.2.8.2,1.2.1.8,0,1.6,0,2.4,0,.1,0,.2-.2.2-.6,0-1.2.1-1.8,0,0,0,0,0,0,0-.4,0-.3,0-.3-.4,0-.6.1-1.2.2-1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160,13.2c0,.5-.1,1-.2,1.5,0,.1,0,.2-.2.2-.5,0-.9-.1-1.4-.2-.1,0-.2,0-.1-.2.2-.6.2-1.2.1-1.9,0-.3,0-.6,0-.9,0-.1,0-.2.2-.2.5-.1,1-.1,1.5-.1,0,0,.2,0,.2,0,.1,0,.2,0,.1.2,0,.5-.1,1.1-.2,1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M158.7,23.3s0,0-.1,0c0,0,0,0,0,0-.6-.3-1-.8-1.3-1.3-.4-.8-.5-1.6-.5-2.5,0-.1,0-.1.1,0,.4.2.9.4,1.4.5.2,0,.5.1.7.2.2,0,.2.1.1.2-.1,1-.3,2.1-.4,3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M159.4,23.4c0,0-.1,0-.2,0,.1-1,.2-2,.4-3,0-.3,0-.3.4-.3.5,0,1,0,1.4,0,.1,0,.3,0,.4,0,0,0,.1,0,0,.1-.3,1-.7,1.9-1.4,2.7-.3.3-.6.5-.9.6,0,0,0,0-.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.4,13.2c0-.5.1-1,.2-1.6,0,0,0-.2.2-.1.5.1,1,.2,1.4.4.1,0,.2.1.1.3,0,.4-.2.8-.3,1.2-.2.5-.2,1.1-.2,1.6,0,.1,0,.2-.2.1-.4,0-.8-.1-1.2-.2-.1,0-.2,0-.1-.2,0-.5.1-1,.2-1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M164.3,19c0,.5-.1.9-.3,1.4-.6,1.5-1.6,2.4-3.1,2.9,0,0,0,0-.1,0,0,0,0,0,0-.1.8-.8,1.2-1.7,1.5-2.8,0-.3.2-.5.5-.6.6-.1,1-.5,1.5-.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M163.5,15.8c.2.5.5,1,.6,1.5,0,.3.1.5.1.8-.2.2-.3.5-.6.6-.3.2-.7.4-1.1.5-.2,0-.1,0-.1-.1.1-.8.1-1.6,0-2.4,0-.3-.1-.7-.2-1,0-.2,0-.2.1-.2.4,0,.7,0,1.1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162.4,8.2c.3.2.6.4.8.6,1,1.1,1.3,2.4.9,3.8,0,0,0,0,0,0-.3-.4-.7-.7-1.1-.9,0,0,0-.2,0-.2,0-.7,0-1.4,0-2.1,0-.4-.2-.8-.4-1.2,0,0,0,0,0-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M163.9,13.3c-.4.6-.5,1.3-.4,2.1-.4,0-.7,0-1.1-.1,0,0-.1,0-.1-.2,0-.4,0-.8.1-1.2.1-.5.3-1,.4-1.5,0-.1,0-.2.2,0,.3.2.6.5.8.8,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.7,23.3s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.8,17.8c-.1.5-.1.9,0,1.4.2,1.6.9,2.8,2.2,3.6,0,0,0,0,.1,0,0,0,0,0,0-.1-.5-.9-.7-2-.7-3.1,0-.3,0-.5-.3-.7-.5-.3-.9-.7-1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M156.2,15c-.3.4-.7.8-.9,1.3-.1.2-.2.5-.3.8,0,.3.2.5.4.8.2.3.5.6.9.8.1,0,.1,0,.1-.1,0-.8.3-1.6.5-2.3.1-.3.3-.6.4-.9,0-.1,0-.2,0-.2-.3,0-.7,0-1-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M159.1,7.8c-.3,0-.6.2-.9.4-1.2.8-1.8,2-1.7,3.5,0,0,0,0,0,0,.4-.3.8-.5,1.2-.6.1,0,.1-.1.1-.2,0-.7.3-1.4.6-2,.2-.4.4-.7.7-1.1,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M156.5,12.4c.2.7.2,1.4,0,2.1.3,0,.7,0,1,.1,0,0,.1,0,.1-.1,0-.4.2-.8.2-1.2,0-.5,0-1,0-1.5,0-.1,0-.2-.1-.1-.4.1-.7.3-.9.6,0,0,0,0,0,0h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHasPeanut);
export default __webpack_public_path__ + "static/media/hasPeanut.4bce160e75b24ff98617a360d2e0400b.svg";
export { ForwardRef as ReactComponent };